import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import style from './style.vue';

@Component({
  components: {},
  mixins: [style],
})
export default class Blank extends Vue {
  @Prop({ default: () => {} })
    value: DisplayBlankData;

  @Prop({ default: false })
    disabled: boolean;

  data: DisplayBlankData = {};

  @Watch('value', { deep: true, immediate: true })
  watchValue(n, o) {
    if (JSON.stringify(n) !== JSON.stringify(o)) {
      this.data = n;
    }
  }

  @Watch('data', { deep: true })
  watchData() {
    this.$emit('input', this.data);
  }

  render(h) {
    return (
      <div class="blank" key={this.data.sort}>
        <el-row>
          <el-col span={6} class="title">
            空白高度
          </el-col>
          <el-col span={18}>
            <el-slider step={2} v-model={this.data.desc.bHeight} min={8} max={80} disabled={this.disabled}></el-slider>
          </el-col>
        </el-row>
      </div>
    );
  }
}
